module.exports = __webpack_public_path__ + "media/external hemorrhoid.61d7d95b.wav";